import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

@Injectable()
export class PlacementService {

    private api_url_placement_search_dockets = './api/server.php?cmd=PLACEMENT_SEARCH_DOCKETS';
    private api_url_placement_details_docket = './api/server.php?cmd=PLACEMENT_DETAILS_DOCKET';
    private api_url_placement_get_locations_for_this_article = './api/server.php?cmd=GET_LOCATIONS_FOR_THIS_ARTICLE';
    private api_url_placement_set_location_for_this_article = './api/server.php?cmd=SET_LOCATION_FOR_THIS_ARTICLE';
    private api_url_placement_set_locations_for_this_article = './api/server.php?cmd=SET_LOCATIONS_FOR_THIS_ARTICLE';
    private api_url_placement_edit_line_placement = './api/server.php?cmd=EDIT_LINE_PLACEMENT';
    private api_url_placement_get_locations_for_this_movement_for_view = './api/server.php?cmd=GET_LOCATIONS_FOR_THIS_MOVEMENT_FOR_VIEW';

    private api_url_insert_new_location_placement = './api/server.php?cmd=INSERT_LOCATION_PLACEMENT';

    constructor(private http: Http) {}

    SearchDockets(docket_name: string, docket_date: string): Promise<Object> {
        return this.http.get(this.api_url_placement_search_dockets
            + '&name=' + docket_name
            + '&operation=IN'
            + '&date=' + docket_date
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    DetailsDocket(id_docket: any): Promise<Object> {
        return this.http.get(this.api_url_placement_details_docket
            + '&id_docket=' + id_docket
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetLocationsForThisArticle(id_article: any, quantity: any): Promise<Object> {
        return this.http.get(this.api_url_placement_get_locations_for_this_article
            + '&id_article=' + id_article
            + '&quantity=' + quantity
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    SetLocationForThisLine(id_movement: any, id_location: any): Promise<Object> {
        return this.http.get(this.api_url_placement_set_location_for_this_article
            + '&id_movement=' + id_movement
            + '&id_location=' + id_location
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    SetLocationsForThisLine(id_movement: any, emplacements: any): Promise<Object> {
        return this.http.get(this.api_url_placement_set_locations_for_this_article
            + '&id_movement=' + id_movement
            + '&emplacements=' + emplacements
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    EditLinePlacement(id_movement: any): Promise<Object> {
        return this.http.get(this.api_url_placement_edit_line_placement
            + '&id_movement=' + id_movement
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    GetLocationsForThisLine_ForView(id_movement: any): Promise<Object> {
        return this.http.get(this.api_url_placement_get_locations_for_this_movement_for_view
            + '&id_movement=' + id_movement
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    insertLocation(location: any, warehouse: any): Promise<Object> {
        return this.http.get(this.api_url_insert_new_location_placement
            + '&warehouse=' + warehouse
            + '&location=' + location.new_location
            + '&reference=' + location.new_reference
            + '&reference_parent=' + location.new_reference_parent
            + '&capacite_max=' + location.capacite_max
            + '&id_article=' + location.id_article
            + '&quantity=' + location.quantity
        )
            .toPromise()
            .then(response => response.json() as Object)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/placement.service.ts